import { useEffect, useState } from 'react';
import styled from 'styled-components';
import {
  ModalContainer,
  ModalInner,
  ModalTitle,
  Section,
  SectionLabel,
  SectionBox,
  ApplyBtnBox,
  ResetBtn,
  ResetBtnText,
  ApplyBtn,
  SelectedRegionBox,
  SelectedRegionText,
  RegionText,
  OptionItem,
  OptionColumn30,
  OptionColumn40,
  OptionItemBg,
} from './RegionModal.styles';
// import Sales from '../../../../service/Sales';
import { useNavigate } from 'react-router-dom';
import MapService from '../../../../service/map/Map';
import { useMapFilterContext } from '../../../../context/MapFilterContext';
import BottomModal from '../../../components/modal/BottomModal';
// import SearchService from '../../../../service/Search';
// import { useMapContext } from '../../../../contexts/MapContext';
// import { usePropertyFilter } from '../../../../contexts/PropertyContext';
// import { getZoomLevelByPNU } from '../../../search/components/ZoomLevel';

interface RegionProps {
  code: string;
  name: string;
  lat: number;
  lng: number;
}

interface RegionModalProps {
  onClose: () => void;
}

const RegionModal = ({ onClose }: RegionModalProps) => {
  const nav = useNavigate();
  const [ctp, setCtp] = useState('');
  const [sig, setSig] = useState('');
  const [emd, setEmd] = useState('');
  const [ctpRegion, setCtpRegion] = useState('');
  const [sigRegion, setSigRegion] = useState('');
  const [emdRegion, setEmdRegion] = useState('');
  const [ctpList, setCtpList] = useState<RegionProps[]>([]);
  const [sigList, setSigList] = useState<RegionProps[]>([]);
  const [emdList, setEmdList] = useState<RegionProps[]>([]);
  const [tempLatLng, setTempLatLng] = useState({ lat: 0, lng: 0 });
  // const { setLatLng, setPnu, setZoomLevel } = useMapContext();
  // const { setPropertyPnu, setAddress } = usePropertyFilter();
  const getRegion = async (region: string) => {
    try {
      const res = await MapService.regionList(region);
      return res.data as RegionProps[];
    } catch (e) {
      console.log(e);
      return [];
    }
  };

  useEffect(() => {
    if (ctp === '') {
      getRegion('').then(setCtpList);
    }
  }, []);

  useEffect(() => {
    if (ctp !== '') {
      getRegion(ctp).then(setSigList);
    } else {
      setSigList([]);
    }
  }, [ctp]);

  useEffect(() => {
    const loadEmdList = async () => {
      if (sig !== '') {
        const emdRegions = await getRegion(sig);
        setEmdList(emdRegions);
        if (emdRegions.length > 0) {
          setEmd(emdRegions[0].code);
          setEmdRegion(emdRegions[0].name);
          setTempLatLng({ lat: emdRegions[0]?.lat, lng: emdRegions[0]?.lng });
        }
      } else {
        setEmdList([]);
        setEmd('');
        setEmdRegion('');
      }
    };
    loadEmdList();
  }, [sig]);

  const handleReset = () => {
    setCtp('');
    setSig('');
    setEmd('');
    setSigList([]);
    setEmdList([]);
  };

  const checkAllSelected = () => {
    return ctp !== '' && sig !== '';
  };

  const { setLatLng } = useMapFilterContext();

  return (
    <BottomModal onClose={onClose}>
      <ModalInner smallDevice={true}>
        <ModalTitle>
          <span>지역 설정</span>
          <img
            src="/assets/images/close/close-dark-gray.svg"
            alt="Close"
            onClick={onClose}
            style={{ cursor: 'pointer', width: '24px', height: '24px' }}
          />
        </ModalTitle>
        <Section>
          <SectionLabel>지역을 선택해 주세요 </SectionLabel>
          <SelectedRegionBox>
            {ctp === '' ? (
              <RegionText>도/시 선택</RegionText>
            ) : (
              <SelectedRegionText>{ctpRegion}</SelectedRegionText>
            )}
            <img
              src="/assets/images/arrow/arrow-right-darkgray.svg"
              alt=""
              style={{ width: '24px', height: '24px' }}
            />
            {sig === '' ? (
              <RegionText>시/군/구 선택</RegionText>
            ) : (
              <SelectedRegionText>{sigRegion}</SelectedRegionText>
            )}
            <img
              src="/assets/images/arrow/arrow-right-darkgray.svg"
              alt=""
              style={{ width: '24px', height: '24px' }}
            />
            {emd === '' ? (
              <RegionText>읍/면/동 선택</RegionText>
            ) : (
              <SelectedRegionText>{emdRegion}</SelectedRegionText>
            )}
          </SelectedRegionBox>
        </Section>
        <SectionBox
          style={{
            height: '100%',
            overflow: 'auto' /* 스크롤 유지하면서 숨기기 */,

            display: 'flex',
          }}
        >
          <OptionColumn30
            style={{
              height: '100%',
            }}
          >
            {ctpList.map((item, index) => (
              <OptionItem
                key={index}
                selected={ctp === item.code}
                onClick={() => {
                  setCtp(item.code);
                  setCtpRegion(item.name);
                  if (ctp !== item.code) {
                    setSig('');
                    setEmd('');
                    setSigList([]);
                    setEmdList([]);
                  }
                }}
              >
                {item.name}
              </OptionItem>
            ))}
          </OptionColumn30>
          <OptionColumn40
            style={{
              height: 'auto',
            }}
          >
            {sigList.map((item, index) => (
              <OptionItemBg
                key={index}
                selected={sig === item.code}
                onClick={() => {
                  setSig(item.code);
                  setSigRegion(item.name);
                  if (sig !== item.code) {
                    setEmd('');
                    setEmdList([]);
                  }
                }}
              >
                {item.name}
              </OptionItemBg>
            ))}
          </OptionColumn40>
          <OptionColumn40
            style={{
              height: 'auto',
            }}
          >
            {emdList.map((item, index) => (
              <OptionItemBg
                key={index}
                selected={emd === item.code}
                onClick={() => {
                  setEmd(item.code);
                  setEmdRegion(item.name);
                  setTempLatLng({ lat: item.lat, lng: item.lng });
                }}
              >
                {item.name}
              </OptionItemBg>
            ))}
          </OptionColumn40>
        </SectionBox>
        <ApplyBtnBox>
          <ResetBtn onClick={handleReset}>
            <img
              src="/assets/images/icon/gray-reset.svg"
              alt=""
              style={{ width: '24px', height: '24px' }}
            />
            <ResetBtnText>초기화</ResetBtnText>
          </ResetBtn>
          <ApplyBtn
            onClick={() => {
              if (!checkAllSelected()) {
                //시도만 선택했을 경우 api호출이 되지 않게하기 위함
                return;
              } else {
                setLatLng({
                  lat: tempLatLng.lat,
                  lng: tempLatLng.lng,
                });
                onClose();
                // SearchService.searchLog(
                //   ctpRegion + ' ' + sigRegion + ' ' + emdRegion,
                //   emd,
                // );
                // getCoord(emd);
              }
            }}
            active={checkAllSelected()}
          >
            {checkAllSelected()
              ? `${emdList.find((item) => item.code === emd)?.name || emd} 결과보기`
              : '지역선택'}
          </ApplyBtn>
        </ApplyBtnBox>
      </ModalInner>
    </BottomModal>
  );
};

export default RegionModal;
